import { LOCALE } from "core/interfaces";

import { boolToCommonStatus } from "~/common/helpers/bool-to-common-status";
import { collectionNormalize } from "~/common/helpers/collection-adapter";
import { commonStatusToBool } from "~/common/helpers/common-status-to-bool";
import { extractTranslation } from "~/common/helpers/extract-translation";
import { kindNormalize } from "~/common/helpers/kind-adapter";
import { materialNormalize } from "~/common/helpers/material-adapter";
import { sizeDenormalize, sizeNormalize } from "~/common/helpers/size-adapter";
import type { ItemPrototype, ItemPrototypeAdapted } from "~/common/interfaces/entities/item-prototype.interface";

/** @warn method could work not as expected */
export const itemPrototypeDenormalize = (
	itemPrototype: ItemPrototypeAdapted
): ItemPrototype => {
	const { name: _name, description: _description, isActive, sizes, ...rest } = itemPrototype;

	return {
		sizes: sizes.map(size => sizeDenormalize(size)),
		isActive: commonStatusToBool(isActive),
		...rest
	};
};

export const itemPrototypeNormalize = (
	locale: Ref<LOCALE>,
	itemPrototype: ItemPrototype
): ItemPrototypeAdapted => {
	const { isActive, translations, kind, materials, collections, sizes, imageThumbnailId, ...rest } = itemPrototype;

	const translation = extractTranslation(locale.value, translations);

	return {
		name: {
			imageId: imageThumbnailId,
			name: translation ? translation.name : "NAME"
		},
		description: translation ? translation.description : "DESCRIPTION",
		isActive: boolToCommonStatus(isActive),
		translations,
		kind: kind && kindNormalize(locale, kind),
		materials: materials ? materials.map(material => materialNormalize(locale, material)) : [],
		collections: collections ? collections.map(collection => collectionNormalize(locale, collection)) : [],
		sizes: sizes ? sizes.map(size => sizeNormalize(size)) : [],
		imageThumbnailId,
		...rest
	};
};
